const data = [
  {
    title: "Amazing Performance",
    description:
      "The rice transplanter has significantly improved our planting efficiency. It saves time, reduces labor costs, and ensures uniform spacing, leading to better crop growth. Even in wet fields, the machine performs smoothly without damaging seedlings. Ideal for medium to large farms—definitely a game-changer for paddy cultivation!",
    image:
      "https://assets.khetigaadi.com/new-implement/KubotaCombineHarvesterV2403-M-DI-TE-CS1T_0_1461318716.jpg",
    date: "2025-01-25",
    reviewer: "Ramesh Patel",
  },
  {
    title: "Best Value Deal",
    description:
      "This tractor delivers excellent performance across all types of fields. The engine is powerful, fuel consumption is low, and it's easy to operate for long hours. The build quality feels solid and maintenance is minimal. A reliable partner for ploughing, hauling, and tilling—perfect for both small and large-scale farming.",
    image:
      "https://assets.khetigaadi.com/tr:h-350,w-500/new-tractor/Kubota-MU-5502-4WD1644842590.png",
    date: "2025-04-23",
    reviewer: "Sumit Pal",
  },
  {
    title: "Highly Recommended",
    description: "Sturdy build, powerful engine, and smooth ride every season.",
    image:
      "https://assets.khetigaadi.com/new-implement/KubotaRiceTransplanterNSP6W_0_1498477037.png",
    date: "2025-04-23",
    reviewer: "Ajay Kumar",
  },
  {
    title: "Reliable and Durable",
    description: "Used daily for months, still performs like brand new.",
    image:
      "https://assets.khetigaadi.com/tr:h-350,w-500/new-tractor/Kubota-MU-5502-4WD1644842590.png",
    date: "2025-04-23",
    reviewer: "Pooja Singh",
  },
  {
    title: "Great Support Service",
    description:
      "Quick installation, helpful team, and responsive service every call.",
    image: "https://example.com/images/review5.jpg",
    date: "2025-04-22",
    reviewer: "Naveen Sharma",
  },
  {
    title: "Perfect for Farming",
    description:
      "Ideal for ploughing, tilling, and transporting with minimal effort.",
    image:
      "https://assets.khetigaadi.com/new-implement/KubotaCombineHarvesterV2403-M-DI-TE-CS1T_0_1461318716.jpg",
    date: "2025-04-22",
    reviewer: "Meena Joshi",
  },
  {
    title: "Impressive Features",
    description:
      "Modern design, strong tires, and digital dashboard look premium.",
    image:
      "https://assets.khetigaadi.com/new-implement/KubotaCombineHarvesterV2403-M-DI-TE-CS1T_0_1461318716.jpg",
    date: "2025-04-10",
    reviewer: "Suresh Yadav",
  },
];

// reviewsApi.ts
export const fetchReviews = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data);
    }, 300); 
  });
};
